export default "__VITE_ASSET__BLnASO8Q__"